// Site header: announcement banners and the navigation bars.
// Converted from the Webflow "navigation-global" symbol.

import { SlideIn } from '@components/interactions';
import {
  DismissTrigger,
  Dismissible,
  Dropdown,
  DropdownList,
  DropdownToggle,
  GithubStars,
  NavButton,
  NavLink,
  NavMenu,
  Navbar,
} from '@components/webflow';

export function SiteHeader({ banner }: { banner: boolean }) {
  return (
    <div className="navigation-global">
      {banner && (
        <Dismissible className="banner10_component" as="section" mode="hide">
          <SlideIn className="padding-global" as="div">
            <div className="banner10_content-wrapper">
              <div className="banner10_content">
                <a href="https://luma.com/2f5n3nr1" target="_blank" className="button is-banner w-inline-block">
                  <div className="icon-embed-xsmall w-embed">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M12.4333 15.4167C11.8664 15.4167 11.3885 15.221 10.9996 14.8296C10.6107 14.4381 10.4162 13.9589 10.4162 13.3921C10.4162 12.8252 10.6119 12.3472 11.0033 11.9584C11.3949 11.5695 11.874 11.375 12.4408 11.375C13.0078 11.375 13.4857 11.5707 13.8746 11.9621C14.2635 12.3536 14.4579 12.8328 14.4579 13.3996C14.4579 13.9666 14.2622 14.4445 13.8708 14.8334C13.4793 15.2222 13.0001 15.4167 12.4333 15.4167ZM3.79437 18.4579C3.41104 18.4579 3.07868 18.3172 2.79729 18.0357C2.51576 17.7543 2.375 17.4219 2.375 17.0386V4.21148C2.375 3.82676 2.51576 3.49322 2.79729 3.21086C3.07868 2.92836 3.41104 2.78711 3.79437 2.78711H5.10375V2.24857C5.10375 2.04926 5.17292 1.88086 5.31125 1.74336C5.44972 1.60586 5.61806 1.53711 5.81625 1.53711C6.02028 1.53711 6.19236 1.60586 6.3325 1.74336C6.47264 1.88086 6.54271 2.04926 6.54271 2.24857V2.78711H13.4565V2.24857C13.4565 2.04926 13.5257 1.88086 13.6642 1.74336C13.8025 1.60586 13.9708 1.53711 14.169 1.53711C14.3731 1.53711 14.5452 1.60586 14.6852 1.74336C14.8253 1.88086 14.8954 2.04926 14.8954 2.24857V2.78711H16.2048C16.5895 2.78711 16.9231 2.92836 17.2054 3.21086C17.4879 3.49322 17.6292 3.82676 17.6292 4.21148V17.0386C17.6292 17.4219 17.4879 17.7543 17.2054 18.0357C16.9231 18.3172 16.5895 18.4579 16.2048 18.4579H3.79437ZM3.79437 17.0386H16.2048V8.12503H3.79437V17.0386ZM3.79437 6.87503H16.2048V4.21148H3.79437V6.87503Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                  <div className="button_banner-text">Oct 22: DBOS User Group online meeting</div>
                </a>
              </div>
              <DismissTrigger href="#" className="banner10_close-button w-inline-block" as="a">
                <div className="icon-embed-small w-embed">
                  <svg width="100%" height="100%" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M22.8354 22.864L22.3639 23.3354C22.1036 23.5957 21.6815 23.5957 21.4211 23.3354L16 17.9142L10.5788 23.3353C10.3185 23.5957 9.89638 23.5957 9.63603 23.3353L9.16462 22.8639C8.90427 22.6036 8.90427 22.1815 9.16462 21.9211L14.5858 16.5L9.16462 11.0788C8.90427 10.8185 8.90427 10.3964 9.16462 10.136L9.63602 9.66463C9.89637 9.40428 10.3185 9.40428 10.5788 9.66463L16 15.0858L21.4211 9.66462C21.6815 9.40427 22.1036 9.40427 22.3639 9.66462L22.8354 10.136C23.0957 10.3964 23.0957 10.8185 22.8354 11.0788L17.4142 16.5L22.8354 21.9211C23.0957 22.1815 23.0957 22.6036 22.8354 22.864Z"
                      fill="currentColor"
                    />
                    {'\n'}
                  </svg>
                </div>
              </DismissTrigger>
            </div>
          </SlideIn>
        </Dismissible>
      )}
      <Navbar
        data-animation="default"
        className="navbar5_component w-nav"
        data-easing2="ease"
        fs-scrolldisable-element="smart-nav"
        data-easing="ease"
        data-collapse="medium"
        role="banner"
        data-duration="400"
      >
        <div className="navbar5_container">
          <NavLink href="/" className="navbar5_logo-link w-nav-brand">
            <img
              width="108"
              src="/assets/images/67241465129b580e4b924af4_Vectors-Wrapper.svg"
              alt="DBOS - Logo"
              className="navigation-logo-new"
            />
          </NavLink>
          <NavMenu role="navigation" className="navbar5_menu w-nav-menu">
            <div className="navbar5_menu-left">
              <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                <DropdownToggle className="navbar-dropdown8_dropdown-toggle w-dropdown-toggle">
                  <div>Products</div>
                  <div className="dropdown-chevron w-embed">
                    <svg
                      width=" 100%"
                      height=" 100%"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {'\n'}
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownList className="navbar-dropdown8_dropdown-list w-dropdown-list">
                  <div className="navbar-dropdown8_dropdown-link-list">
                    <NavLink href="/dbos-transact" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M9.39584 16.5625L13.4583 8.56246H10.6667V3.43746L6.60417 11.3958H9.39584V16.5625ZM10 18.3333C8.84723 18.3333 7.76389 18.1145 6.75001 17.677C5.73612 17.2395 4.85417 16.6458 4.10417 15.8958C3.35417 15.1458 2.76042 14.2638 2.32292 13.25C1.88542 12.2361 1.66667 11.1527 1.66667 9.99996C1.66667 8.84718 1.88542 7.76385 2.32292 6.74996C2.76042 5.73607 3.35417 4.85413 4.10417 4.10413C4.85417 3.35413 5.73612 2.76038 6.75001 2.32288C7.76389 1.88538 8.84723 1.66663 10 1.66663C11.1528 1.66663 12.2361 1.88538 13.25 2.32288C14.2639 2.76038 15.1458 3.35413 15.8958 4.10413C16.6458 4.85413 17.2396 5.73607 17.6771 6.74996C18.1146 7.76385 18.3333 8.84718 18.3333 9.99996C18.3333 11.1527 18.1146 12.2361 17.6771 13.25C17.2396 14.2638 16.6458 15.1458 15.8958 15.8958C15.1458 16.6458 14.2639 17.2395 13.25 17.677C12.2361 18.1145 11.1528 18.3333 10 18.3333ZM14.6563 14.6612C15.941 13.3798 16.5833 11.8277 16.5833 10.005C16.5833 8.18218 15.9426 6.62843 14.6613 5.34371C13.3799 4.05899 11.8278 3.41663 10.005 3.41663C8.18223 3.41663 6.62848 4.05732 5.34376 5.33871C4.05903 6.6201 3.41667 8.17218 3.41667 9.99496C3.41667 11.8177 4.05737 13.3715 5.33876 14.6562C6.62014 15.9409 8.17223 16.5833 9.99501 16.5833C11.8178 16.5833 13.3715 15.9426 14.6563 14.6612Z"
                              fill="url(#paint0_linear_9075_5431)"
                            />
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9075_5431"
                              x1="5"
                              y1="1.66663"
                              x2="18.0078"
                              y2="1.66663"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">DBOS Transact</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Open source durable execution library
                        </p>
                      </div>
                    </NavLink>
                    <NavLink href="/dbos-conductor" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M7.71429 12.2857V7.71429H12.2857V12.2857H7.71429ZM9.42857 10.5714H10.5714V9.42857H9.42857V10.5714ZM7.14286 18V15.7143H6C5.53968 15.7143 5.13889 15.5437 4.79762 15.2024C4.45635 14.8611 4.28571 14.4603 4.28571 14V12.8571H2V11.1429H4.28571V8.85714H2V7.14286H4.28571V6C4.28571 5.53968 4.45635 5.13889 4.79762 4.79762C5.13889 4.45635 5.53968 4.28571 6 4.28571H7.14286V2H8.85714V4.28571H11.1429V2H12.8571V4.28571H14C14.4603 4.28571 14.8611 4.45635 15.2024 4.79762C15.5437 5.13889 15.7143 5.53968 15.7143 6V7.14286H18V8.85714H15.7143V11.1429H18V12.8571H15.7143V14C15.7143 14.4603 15.5437 14.8611 15.2024 15.2024C14.8611 15.5437 14.4603 15.7143 14 15.7143H12.8571V18H11.1429V15.7143H8.85714V18H7.14286ZM14 14V6H6V14H14Z"
                              fill="url(#paint0_linear_9075_5437)"
                            />
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9075_5437"
                              x1="4.5"
                              y1="2"
                              x2="17.6875"
                              y2="2"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">DBOS Conductor</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          {'Control plane for agents & workflows'}
                        </p>
                      </div>
                    </NavLink>
                  </div>
                </DropdownList>
              </Dropdown>
              <NavLink href="/dbos-pricing" className="navbar5_link w-nav-link">
                Pricing
              </NavLink>
              <NavLink href="/customer-stories" className="navbar5_link w-nav-link">
                Customers
              </NavLink>
              <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                <DropdownToggle className="navbar-dropdown8_dropdown-toggle w-dropdown-toggle">
                  <div>Resources</div>
                  <div className="dropdown-chevron w-embed">
                    <svg
                      width=" 100%"
                      height=" 100%"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {'\n'}
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownList className="navbar-dropdown8_dropdown-list w-dropdown-list">
                  <div className="navbar-dropdown8_dropdown-link-list">
                    <NavLink href="/about" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M16.604 11.048C17.2131 10.0101 17.4761 8.80528 17.355 7.60797C17.176 5.82397 16.18 4.24697 14.552 3.16797L13.447 4.83397C14.566 5.57597 15.247 6.63297 15.365 7.80797C15.4194 8.35407 15.3514 8.90543 15.166 9.42195C14.9806 9.93847 14.6823 10.4072 14.293 10.794L13.101 11.986L14.719 12.461C18.951 13.701 19 17.957 19 18H21C21 16.211 20.044 12.715 16.604 11.048Z"
                              fill="currentColor"
                            />
                            {'\n'}
                            <path
                              d="M9.5 12C11.706 12 13.5 10.206 13.5 8C13.5 5.794 11.706 4 9.5 4C7.294 4 5.5 5.794 5.5 8C5.5 10.206 7.294 12 9.5 12ZM9.5 6C10.603 6 11.5 6.897 11.5 8C11.5 9.103 10.603 10 9.5 10C8.397 10 7.5 9.103 7.5 8C7.5 6.897 8.397 6 9.5 6ZM11 13H8C4.691 13 2 15.691 2 19V20H4V19C4 16.794 5.794 15 8 15H11C13.206 15 15 16.794 15 19V20H17V19C17 15.691 14.309 13 11 13Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">About DBOS</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Meet the team simplifying reliability.
                        </p>
                      </div>
                    </NavLink>
                    <NavLink href="/videos" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M18 7C18 5.897 17.103 5 16 5H4C2.897 5 2 5.897 2 7V17C2 18.103 2.897 19 4 19H16C17.103 19 18 18.103 18 17V13.667L22 17V7L18 10.333V7ZM16.002 17H4V7H16L16.001 11.999L16 12L16.001 12.001L16.002 17Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Videos</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Demos, deep dives, and more DBOS.</p>
                      </div>
                    </NavLink>
                    <NavLink href="/partners" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M11.4027 7.69625L9.38742 5.656C9.21759 5.486 9.13267 5.28608 9.13267 5.05625C9.13267 4.82642 9.21759 4.6265 9.38742 4.4565L11.4027 2.41625C11.5727 2.24642 11.7726 2.1615 12.0024 2.1615C12.2323 2.1615 12.4322 2.24642 12.6022 2.41625L14.6424 4.4565C14.8123 4.6265 14.8972 4.82642 14.8972 5.05625C14.8972 5.28608 14.8123 5.486 14.6424 5.656L12.6022 7.69625C12.4322 7.86608 12.2323 7.951 12.0024 7.951C11.7726 7.951 11.5727 7.86608 11.4027 7.69625ZM1.67767 20.293C1.43317 20.293 1.23009 20.2122 1.06842 20.0505C0.906922 19.889 0.826172 19.6859 0.826172 19.4412V16.1912C0.826172 15.6801 1.00792 15.2437 1.37142 14.882C1.73509 14.5205 2.17051 14.3397 2.67767 14.3397H6.23267C6.52384 14.3397 6.79367 14.4066 7.04217 14.5402C7.2905 14.6739 7.50234 14.8597 7.67767 15.0977C8.16901 15.8097 8.79567 16.3614 9.55767 16.7527C10.3195 17.1441 11.1334 17.3397 11.9994 17.3397C12.8614 17.3397 13.6743 17.1441 14.4382 16.7527C15.2022 16.3614 15.8402 15.8097 16.3522 15.0977C16.5195 14.8597 16.7242 14.6739 16.9662 14.5402C17.2083 14.4066 17.477 14.3397 17.7722 14.3397H21.3272C21.8383 14.3397 22.2748 14.5205 22.6364 14.882C22.9979 15.2437 23.1787 15.6801 23.1787 16.1912V19.4412C23.1787 19.6859 23.0979 19.889 22.9364 20.0505C22.7748 20.2122 22.5717 20.293 22.3272 20.293H17.3272C17.0825 20.293 16.8794 20.2122 16.7179 20.0505C16.5563 19.889 16.4754 19.6859 16.4754 19.4412V17.282C15.8714 17.8122 15.1849 18.2232 14.4159 18.5152C13.6469 18.8072 12.8414 18.9532 11.9994 18.9532C11.1614 18.9532 10.3611 18.8082 9.59842 18.5182C8.83575 18.2282 8.14609 17.8162 7.52942 17.282V19.4412C7.52942 19.6859 7.44859 19.889 7.28692 20.0505C7.12526 20.2122 6.92217 20.293 6.67767 20.293H1.67767ZM3.99942 12.4102C3.23742 12.4102 2.58159 12.1354 2.03192 11.5857C1.48242 11.0362 1.20767 10.3785 1.20767 9.6125C1.20767 8.83783 1.48242 8.17883 2.03192 7.6355C2.58159 7.09233 3.23742 6.82075 3.99942 6.82075C4.77809 6.82075 5.43909 7.09233 5.98242 7.6355C6.52559 8.17883 6.79717 8.83783 6.79717 9.6125C6.79717 10.3785 6.52559 11.0362 5.98242 11.5857C5.43909 12.1354 4.77809 12.4102 3.99942 12.4102ZM19.9994 12.4102C19.2374 12.4102 18.5816 12.1354 18.0319 11.5857C17.4824 11.0362 17.2077 10.3785 17.2077 9.6125C17.2077 8.83783 17.4824 8.17883 18.0319 7.6355C18.5816 7.09233 19.2374 6.82075 19.9994 6.82075C20.7781 6.82075 21.4391 7.09233 21.9824 7.6355C22.5256 8.17883 22.7972 8.83783 22.7972 9.6125C22.7972 10.3785 22.5256 11.0362 21.9824 11.5857C21.4391 12.1354 20.7781 12.4102 19.9994 12.4102Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Partners</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Explore the DBOS ecosystem.</p>
                      </div>
                    </NavLink>
                  </div>
                </DropdownList>
              </Dropdown>
              <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                <DropdownToggle className="navbar-dropdown8_dropdown-toggle w-dropdown-toggle">
                  <div>Docs</div>
                  <div className="dropdown-chevron w-embed">
                    <svg
                      width=" 100%"
                      height=" 100%"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {'\n'}
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownList className="navbar-dropdown8_dropdown-list w-dropdown-list">
                  <div className="navbar-dropdown8_dropdown-link-list">
                    <a
                      href="https://docs.dbos.dev/quickstart"
                      className="navbar-dropdown8_dropdown-link w-inline-block"
                    >
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M11.25 17L11.75 11.5H7.0625L13 3H13.75L13 8.5H17.8958L12 17H11.25ZM3.02083 14.5V13H10L9.77083 14.5H3.02083ZM2 10.75V9.25H6.75L5.70833 10.75H2ZM4 7V5.5H9.41667L8.35417 7H4Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Quickstart</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Launch your first workflow in minutes.
                        </p>
                      </div>
                    </a>
                    <a href="https://docs.dbos.dev/" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M21 3H14C13.2596 3.00251 12.5466 3.28057 12 3.78C11.4534 3.28057 10.7404 3.00251 10 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H8.758C9.284 20 9.8 20.214 10.172 20.586L11.293 21.707C11.302 21.716 11.314 21.719 11.323 21.728C11.409 21.807 11.505 21.877 11.617 21.924H11.619C11.863 22.025 12.137 22.025 12.381 21.924H12.383C12.495 21.877 12.591 21.807 12.677 21.728C12.686 21.719 12.698 21.716 12.707 21.707L13.828 20.586C14.2039 20.2123 14.7119 20.0017 15.242 20H21C21.2652 20 21.5196 19.8946 21.7071 19.7071C21.8946 19.5196 22 19.2652 22 19V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM8.758 18H4V5H10C10.552 5 11 5.449 11 6V18.689C10.3375 18.2422 9.5571 18.0024 8.758 18ZM20 18H15.242C14.443 18 13.658 18.246 13 18.689V6C13 5.449 13.448 5 14 5H20V18Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Docs</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          {'Step-by-step guides & real-world use cases.'}
                        </p>
                      </div>
                    </a>
                    <a href="https://docs.dbos.dev/examples" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M19 10V7C19 5.897 18.103 5 17 5H14C14 3.346 12.654 2 11 2C9.346 2 8 3.346 8 5H5C3.897 5 3 5.897 3 7V10.881L3.659 11.12C4.461 11.41 5 12.166 5 13C5 13.834 4.461 14.59 3.659 14.88L3 15.119V19C3 20.103 3.897 21 5 21H8.881L9.12 20.341C9.41 19.539 10.166 19 11 19C11.834 19 12.59 19.539 12.88 20.341L13.119 21H17C18.103 21 19 20.103 19 19V16C20.654 16 22 14.654 22 13C22 11.346 20.654 10 19 10ZM19 14H17L16.997 19H14.452C13.741 17.78 12.43 17 11 17C9.57 17 8.259 17.78 7.548 19H5V16.452C6.22 15.741 7 14.43 7 13C7 11.57 6.22 10.259 5 9.548V7H10V5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4C11.2652 4 11.5196 4.10536 11.7071 4.29289C11.8946 4.48043 12 4.73478 12 5V7H17V12H19C19.2652 12 19.5196 12.1054 19.7071 12.2929C19.8946 12.4804 20 12.7348 20 13C20 13.2652 19.8946 13.5196 19.7071 13.7071C19.5196 13.8946 19.2652 14 19 14Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Example Applications</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Ready-to-run code to spark your project.
                        </p>
                      </div>
                    </a>
                  </div>
                </DropdownList>
              </Dropdown>
              <NavLink href="/blog" className="navbar5_link w-nav-link">
                Blog
              </NavLink>
            </div>
            <div className="navbar5_menu-right">
              <div className="div-block-62">
                <a
                  href="https://discord.com/invite/jsmC6pXGgX"
                  className="footer5_social-link is-discord w-inline-block"
                >
                  <div className="icon-embed-xsmall w-embed">
                    <svg width="100%" height="100%" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M14.2524 6.66699C14.096 6.94165 13.9556 7.22579 13.828 7.51624C12.6154 7.33629 11.3806 7.33629 10.1649 7.51624C10.0404 7.22579 9.89682 6.94165 9.74048 6.66699C8.60133 6.85958 7.49091 7.19738 6.43793 7.67409C4.3511 10.7333 3.78631 13.7136 4.06711 16.6528C5.28921 17.5462 6.6581 18.2282 8.11632 18.6638C8.44498 18.2282 8.73535 17.7641 8.98424 17.281C8.51199 17.1074 8.05569 16.8896 7.61855 16.637C7.73341 16.5549 7.8451 16.4697 7.95358 16.3876C10.5159 17.581 13.4834 17.581 16.0488 16.3876C16.1573 16.476 16.269 16.5612 16.3839 16.637C15.9467 16.8927 15.4904 17.1074 15.015 17.2842C15.2639 17.7672 15.5542 18.2313 15.8829 18.667C17.3411 18.2313 18.71 17.5525 19.9322 16.6591C20.2639 13.2495 19.3641 10.2945 17.5548 7.67725C16.5051 7.20054 15.3947 6.86273 14.2555 6.6733L14.2524 6.66699ZM9.34161 14.8438C8.55348 14.8438 7.89935 14.1366 7.89935 13.2621C7.89935 12.3876 8.52794 11.6773 9.33843 11.6773C10.1489 11.6773 10.7935 12.3908 10.7807 13.2621C10.7679 14.1335 10.1457 14.8438 9.34161 14.8438ZM14.6576 14.8438C13.8663 14.8438 13.2185 14.1366 13.2185 13.2621C13.2185 12.3876 13.8471 11.6773 14.6576 11.6773C15.4681 11.6773 16.1094 12.3908 16.0967 13.2621C16.0839 14.1335 15.4617 14.8438 14.6576 14.8438Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </a>
                <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                  <DropdownToggle className="navbar-dropdown8_dropdown-toggle is-github w-dropdown-toggle">
                    <div className="div-block-50">
                      <div className="text-block-7">Explore</div>
                      <div className="w-embed">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.97914 0C3.11986 0 0 3.20833 0 7.17748C0 10.3502 1.999 13.0359 4.77214 13.9864C5.11886 14.0579 5.24586 13.832 5.24586 13.642C5.24586 13.4756 5.23443 12.9052 5.23443 12.311C3.293 12.7388 2.88871 11.4554 2.88871 11.4554C2.57671 10.6235 2.11443 10.4097 2.11443 10.4097C1.479 9.97004 2.16071 9.97004 2.16071 9.97004C2.86557 10.0176 3.23543 10.7068 3.23543 10.7068C3.85929 11.8 4.86457 11.4911 5.269 11.3009C5.32671 10.8375 5.51171 10.5166 5.70814 10.3384C4.15971 10.172 2.53057 9.55412 2.53057 6.79715C2.53057 6.01285 2.80771 5.37119 3.24686 4.87215C3.17757 4.69394 2.93486 3.95704 3.31629 2.97077C3.31629 2.97077 3.90557 2.7806 5.23429 3.70752C5.80315 3.55041 6.38982 3.47049 6.97914 3.46981C7.56843 3.46981 8.16914 3.55308 8.72386 3.70752C10.0527 2.7806 10.642 2.97077 10.642 2.97077C11.0234 3.95704 10.7806 4.69394 10.7113 4.87215C11.162 5.37119 11.4277 6.01285 11.4277 6.79715C11.4277 9.55412 9.79857 10.1601 8.23857 10.3384C8.49286 10.5642 8.71229 10.9919 8.71229 11.6693C8.71229 12.6318 8.70086 13.4043 8.70086 13.6418C8.70086 13.832 8.828 14.0579 9.17457 13.9866C11.9477 13.0357 13.9467 10.3502 13.9467 7.17748C13.9581 3.20833 10.8269 0 6.97914 0Z"
                            fill="currentColor"
                          />
                          {'\n'}
                        </svg>
                      </div>
                      <GithubStars id="github-stars" />
                    </div>
                    <div className="dropdown-chevron w-embed">
                      <svg
                        width=" 100%"
                        height=" 100%"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {'\n'}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                          fill="currentColor"
                        />
                        {'\n'}
                      </svg>
                    </div>
                  </DropdownToggle>
                  <DropdownList className="navbar-dropdown8_dropdown-list dropdown-list-alt w-dropdown-list">
                    <div className="navbar-dropdown8_dropdown-link-list dropdown-list-alt">
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-py"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos/dbos-transact-py</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Python</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-ts"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos/dbos-transact-ts</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Durable Execution Library - TypeScript
                        </p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-go"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos-inc/dbos-transact-go</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Go</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-rust"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos/dbos-transact-rust</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Rust</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-java"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos-inc/dbos-transact-java</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Java</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-demo-apps"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos-inc/dbos-demo-apps</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Demo DBOS applications</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc"
                        className="navbar-dropdown9_dropdown-external w-inline-block"
                      >
                        <div className="text-weight-medium">See all repos</div>
                        <div className="w-embed">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M10.8334 2.5L13.5775 5.24417L7.74419 11.0775L8.92252 12.2558L14.7559 6.4225L17.5 9.16667V2.5H10.8334Z"
                              fill="currentColor"
                            />
                            {'\n'}
                            <path
                              d="M15.8333 15.8333H4.16667V4.16667H10L8.33333 2.5H4.16667C3.2475 2.5 2.5 3.2475 2.5 4.16667V15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5H15.8333C16.7525 17.5 17.5 16.7525 17.5 15.8333V11.6667L15.8333 10V15.8333Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </DropdownList>
                </Dropdown>
              </div>
              <a href="https://console.dbos.dev/" className="button secondary-small w-inline-block">
                <div className="text-block-4 secondary-small-3">Sign in</div>
                <div className="icon-arrow-right secondary-small-4 w-embed">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                      fill="var(--_color-scheme-july-2025---background)"
                    />
                    {'\n'}
                  </svg>
                </div>
                <div className="icon-chevron-right secondary-small-5 w-embed">
                  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                      fill="#F3F6F8"
                    />
                    {'\n'}
                  </svg>
                </div>
              </a>
              <a href="https://console.dbos.dev/" className="button primary-small-2 w-inline-block">
                <div className="text-block-9">Get started</div>
                <div className="icon-arrow-right primary-small-4 w-embed">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                      fill="var(--_color-scheme-july-2025---background)"
                    />
                    {'\n'}
                  </svg>
                </div>
                <div className="icon-chevron-right primary-small-5 w-embed">
                  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                      fill="#F3F6F8"
                    />
                    {'\n'}
                  </svg>
                </div>
              </a>
            </div>
          </NavMenu>
          <NavButton className="navbar5_menu-button w-nav-button">
            <div className="menu-icon1">
              <div className="menu-icon1_line-top" />
              <div className="menu-icon1_line-middle">
                <div className="menu-icon1_line-middle-inner" />
              </div>
              <div className="menu-icon1_line-bottom" />
            </div>
          </NavButton>
        </div>
      </Navbar>
      {banner && (
        <Dismissible className="notification-banner" as="section" mode="collapse">
          <div className="notification-container">
            <DismissTrigger className="notification-banner-link w-embed" as="div">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                {'\n'}
                <path
                  d="M4.75684 5.07104L13.2421 13.5563"
                  stroke="currentColor"
                  strokeWidth="1.32353"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                {'\n'}
                <path
                  d="M13.2421 5.07112L4.75684 13.5564"
                  stroke="currentColor"
                  strokeWidth="1.32353"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                {'\n'}
              </svg>
            </DismissTrigger>
            <a
              href="https://lu.ma/sfx9yccw"
              target="_blank"
              className="button tertiary-large-2 is-banner w-inline-block"
            >
              <div className="text-block-4 tertiary-large-3">{'July 24:\u00a0DBOS\u00a0User Group Meeting'}</div>
              <div className="icon-arrow-right tertiary-large-4 w-embed">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                    fill="var(--_color-scheme-july-2025---background)"
                  />
                  {'\n'}
                </svg>
              </div>
              <div className="icon-chevron-right tertiary-large-5 w-embed">
                <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                    fill="#F3F6F8"
                  />
                  {'\n'}
                </svg>
              </div>
            </a>
          </div>
        </Dismissible>
      )}
      <Navbar
        data-collapse="medium"
        data-animation="default"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="navigation-w-banner w-nav"
      >
        <div className="navigation-wrap">
          <div className="navigation-left">
            <NavLink href="/" className="logo-link w-nav-brand">
              <img
                width="108"
                src="/assets/images/67241465129b580e4b924af4_Vectors-Wrapper.svg"
                alt="DBOS - Logo"
                className="navigation-logo"
              />
            </NavLink>
            <div className="menu">
              <NavMenu role="navigation" className="navigation-items w-nav-menu">
                <Dropdown data-delay="400" data-hover="false" className="navigation-dropdown w-dropdown">
                  <DropdownToggle className="navigation-dropdown-label w-dropdown-toggle">
                    <div className="w-icon-dropdown-toggle" />
                    <div>Products</div>
                  </DropdownToggle>
                  <DropdownList className="navigation-dropdown-list w-dropdown-list">
                    <NavLink href="/dbos-transact" className="navigation-dropdown-item w-inline-block">
                      <div className="w-embed">
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10 0.00195312C9.47421 0.00195312 8.95768 0.140138 8.50214 0.402641L1.50386 4.40165L1.5 4.40388C1.04439 4.66692 0.66597 5.04515 0.402692 5.50062C0.139414 5.95609 0.000539601 6.47279 0 6.99888V15.0009C0.000539601 15.527 0.139414 16.0437 0.402692 16.4992C0.66597 16.9547 1.04439 17.3329 1.5 17.5959L1.50386 17.5981L8.5 21.5959L8.50185 21.597C8.95745 21.8596 9.4741 21.9979 10 21.9979C10.5259 21.9979 11.0426 21.8596 11.4982 21.597L11.5 21.5959L18.4961 17.5981L18.5 17.5959C18.9556 17.3329 19.334 16.9547 19.5973 16.4992C19.8606 16.0437 19.9995 15.527 20 15.0009V6.99888C19.9995 6.47279 19.8606 5.95609 19.5973 5.50062C19.334 5.04515 18.9556 4.66692 18.5 4.40387L11.5 0.403877L11.4979 0.402673C11.0424 0.140149 10.5258 0.00195312 10 0.00195312ZM9.5 2.13593C9.65202 2.04816 9.82446 2.00195 10 2.00195C10.1755 2.00195 10.348 2.04817 10.5 2.13594L17.5 6.13593L17.5016 6.13685C17.6527 6.22449 17.7783 6.35021 17.8658 6.50151C17.9535 6.65333 17.9998 6.82556 18 7.00093V14.9989C17.9998 15.1742 17.9535 15.3465 17.8658 15.4983C17.7783 15.6496 17.6527 15.7753 17.5016 15.863L17.5 15.8639L10.5039 19.8617L10.5 19.8639C10.348 19.9516 10.1755 19.9979 10 19.9979C9.82446 19.9979 9.65202 19.9516 9.5 19.8639L2.5 15.8639L2.49842 15.863C2.34726 15.7753 2.22169 15.6496 2.13423 15.4983C2.04654 15.3466 2.00025 15.1745 2 14.9993V7.0005C2.00025 6.82528 2.04654 6.65321 2.13423 6.50151C2.22169 6.35021 2.34726 6.22448 2.49842 6.13684L2.5 6.13593L9.49614 2.13815L9.5 2.13593ZM11.8321 5.55481C12.1384 5.09528 12.0142 4.47441 11.5547 4.16806C11.0952 3.8617 10.4743 3.98588 10.168 4.44541L6.16795 10.4454C5.96338 10.7523 5.94431 11.1468 6.11833 11.472C6.29235 11.7971 6.63121 12.0001 7 12.0001H11.1315L8.16795 16.4454C7.8616 16.9049 7.98577 17.5258 8.4453 17.8322C8.90483 18.1385 9.5257 18.0143 9.83205 17.5548L13.8321 11.5548C14.0366 11.248 14.0557 10.8534 13.8817 10.5282C13.7077 10.2031 13.3688 10.0001 13 10.0001H8.86852L11.8321 5.55481Z"
                            fill="url(#paint0_linear_318_12677)"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_318_12677"
                              x1="0"
                              y1="12.5"
                              x2="20"
                              y2="12.5"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop offset="0.03" stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.34" stopColor="#ECFAA0" />
                              {'\n'}
                              <stop offset="0.7" stopColor="#44E3EE" />
                              {'\n'}
                              <stop offset="1" stopColor="#CED7F8" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                      <div className="w-layout-vflex flex-block">
                        <div className="dropdown-item-link">{'DBOS\u00a0Transact'}</div>
                        <div className="text-caption-micro">Open source durable execution library</div>
                      </div>
                    </NavLink>
                    <NavLink href="/dbos-cloud" className="navigation-dropdown-item w-inline-block">
                      <div className="w-embed">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <g clipPath="url(#clip0_285_9660)">
                            {'\n'}
                            <g clipPath="url(#clip1_285_9660)">
                              {'\n'}
                              <path
                                d="M18.0001 10.5H16.7401C16.366 9.051 15.5929 7.73599 14.5088 6.7044C13.4246 5.6728 12.0728 4.96599 10.607 4.66428C9.14124 4.36256 7.6202 4.47804 6.21676 4.99759C4.81332 5.51714 3.58375 6.41993 2.66776 7.60338C1.75177 8.78683 1.1861 10.2035 1.03502 11.6924C0.883935 13.1812 1.1535 14.6826 1.81309 16.026C2.47267 17.3693 3.49583 18.5007 4.76629 19.2916C6.03676 20.0824 7.50359 20.5011 9.00011 20.5H18.0001C19.3262 20.5 20.598 19.9732 21.5356 19.0355C22.4733 18.0979 23.0001 16.8261 23.0001 15.5C23.0001 14.1739 22.4733 12.9021 21.5356 11.9645C20.598 11.0268 19.3262 10.5 18.0001 10.5Z"
                                stroke="url(#paint0_linear_285_9660)"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              {'\n'}
                            </g>
                            {'\n'}
                          </g>
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_285_9660"
                              x1="-6.33077e-10"
                              y1="14"
                              x2="23.2074"
                              y2="9.71125"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop offset="0.03" stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.34" stopColor="#ECFAA0" />
                              {'\n'}
                              <stop offset="0.7" stopColor="#44E3EE" />
                              {'\n'}
                              <stop offset="1" stopColor="#CED7F8" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                            <clipPath id="clip0_285_9660">
                              {'\n'}
                              <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                              {'\n'}
                            </clipPath>
                            {'\n'}
                            <clipPath id="clip1_285_9660">
                              {'\n'}
                              <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                              {'\n'}
                            </clipPath>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                      <div className="w-layout-vflex flex-block">
                        <div className="dropdown-item-link">{'DBOS\u00a0Cloud'}</div>
                        <div className="text-caption-micro">Deploy with a click, scale to millions</div>
                      </div>
                    </NavLink>
                  </DropdownList>
                </Dropdown>
                <NavLink href="/customer-stories" className="navigation-dropdown-label w-nav-link">
                  Customers
                </NavLink>
                <NavLink href="/dbos-pricing" className="navigation-dropdown-label w-nav-link">
                  Pricing
                </NavLink>
                <NavLink href="/blog" className="navigation-dropdown-label w-nav-link">
                  Blog
                </NavLink>
                <a href="https://docs.dbos.dev/" className="navigation-dropdown-label w-nav-link">
                  Docs
                </a>
                <Dropdown data-delay="400" data-hover="false" className="navigation-dropdown w-dropdown">
                  <DropdownToggle className="navigation-dropdown-label w-dropdown-toggle">
                    <div className="w-icon-dropdown-toggle" />
                    <div>Resources</div>
                  </DropdownToggle>
                  <DropdownList className="navigation-dropdown-list w-dropdown-list">
                    <NavLink href="/about" className="navigation-dropdown-item w-inline-block">
                      <div className="w-layout-vflex flex-block">
                        <div className="dropdown-item-link">About DBOS</div>
                        <div className="text-caption-micro">See our story, meet our team.</div>
                      </div>
                    </NavLink>
                    <NavLink href="/videos" className="navigation-dropdown-item w-inline-block">
                      <div className="w-layout-vflex flex-block">
                        <div className="dropdown-item-link">Videos</div>
                        <div className="text-caption-micro">DBOS concepts and best practices</div>
                      </div>
                    </NavLink>
                  </DropdownList>
                </Dropdown>
                <div className="w-layout-vflex button-row-nav">
                  <div className="button-primary-border button-width">
                    <a
                      href="https://console.dbos.dev/login-redirect"
                      className="button-cta button-primary button-navigation button-width w-inline-block"
                    >
                      <div className="text-block">Start your project</div>
                    </a>
                  </div>
                  <a
                    href="https://console.dbos.dev/login-redirect"
                    className="button-cta button-secondary button-width w-inline-block"
                  >
                    <div className="text-block">Login</div>
                  </a>
                </div>
              </NavMenu>
              <NavButton className="menu-button w-nav-button">
                <div className="w-embed">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M3 12H21"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    {'\n'}
                    <path
                      d="M3 6H21"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    {'\n'}
                    <path
                      d="M3 18H21"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    {'\n'}
                  </svg>
                </div>
              </NavButton>
            </div>
          </div>
          <div className="navigation-right">
            <a
              href="https://github.com/dbos-inc/dbos-transact-py"
              target="_blank"
              className="github-container w-inline-block"
            >
              <div className="icon-github w-embed">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M9.00004 0.222656C4.03009 0.222656 0 4.25204 0 9.22269C0 13.1992 2.57878 16.5728 6.15479 17.7629C6.60457 17.8462 6.76974 17.5676 6.76974 17.3299C6.76974 17.1153 6.76134 16.4063 6.75753 15.6543C4.25364 16.1987 3.7253 14.5924 3.7253 14.5924C3.31591 13.5521 2.72602 13.2755 2.72602 13.2755C1.90949 12.7169 2.78757 12.7283 2.78757 12.7283C3.69135 12.7919 4.16724 13.6558 4.16724 13.6558C4.96994 15.0318 6.27267 14.6339 6.78625 14.404C6.867 13.8223 7.10029 13.4253 7.35765 13.2006C5.35866 12.9729 3.25718 12.2012 3.25718 8.75266C3.25718 7.77011 3.60877 6.96719 4.18453 6.33693C4.09108 6.11021 3.78304 5.19486 4.27171 3.95516C4.27171 3.95516 5.02747 3.71326 6.74736 4.87772C7.46522 4.67824 8.23517 4.57829 9.00004 4.5749C9.7649 4.57829 10.5354 4.67824 11.2547 4.87772C12.9725 3.71326 13.7272 3.95516 13.7272 3.95516C14.2171 5.19486 13.9089 6.11021 13.8155 6.33693C14.3925 6.96719 14.7417 7.77004 14.7417 8.75266C14.7417 12.2094 12.6363 12.9706 10.6322 13.1934C10.955 13.4727 11.2426 14.0204 11.2426 14.86C11.2426 16.0642 11.2322 17.0334 11.2322 17.3299C11.2322 17.5694 11.3942 17.85 11.8504 17.7617C15.4245 16.5702 18 13.1979 18 9.22269C18 4.25204 13.9705 0.222656 9.00004 0.222656Z"
                    fill="currentColor"
                  />
                  {'\n'}
                  <path
                    d="M3.36996 13.0432C3.3502 13.0879 3.27975 13.1013 3.21573 13.0707C3.15044 13.0413 3.11373 12.9803 3.13491 12.9355C3.15432 12.8894 3.22477 12.8766 3.28992 12.9075C3.35535 12.9368 3.39262 12.9983 3.36996 13.0432ZM3.81267 13.4382C3.76976 13.478 3.68583 13.4596 3.62887 13.3967C3.57 13.3339 3.55899 13.2501 3.60254 13.2096C3.6468 13.1699 3.72818 13.1884 3.78719 13.2513C3.84606 13.3147 3.8575 13.3981 3.8126 13.4383L3.81267 13.4382ZM4.1164 13.9436C4.06121 13.982 3.971 13.946 3.91531 13.866C3.86018 13.786 3.86018 13.69 3.91651 13.6515C3.97241 13.6131 4.06121 13.6477 4.11768 13.7271C4.17273 13.8085 4.17273 13.9045 4.11633 13.9437L4.1164 13.9436ZM4.62999 14.529C4.58065 14.5834 4.47562 14.5688 4.39868 14.4946C4.32004 14.422 4.29809 14.319 4.34757 14.2646C4.39748 14.2101 4.50314 14.2254 4.58065 14.299C4.65879 14.3715 4.68264 14.4752 4.63006 14.529H4.62999ZM5.29378 14.7266C5.27211 14.7971 5.17089 14.8291 5.06896 14.7992C4.96717 14.7684 4.90054 14.6858 4.92108 14.6146C4.94226 14.5436 5.0439 14.5102 5.1466 14.5423C5.24825 14.573 5.31502 14.6549 5.29385 14.7266H5.29378ZM6.04932 14.8104C6.05187 14.8847 5.9654 14.9462 5.85839 14.9476C5.75075 14.9499 5.66372 14.8898 5.66259 14.8169C5.66259 14.7419 5.74708 14.6809 5.85465 14.6791C5.96166 14.677 6.04932 14.7367 6.04932 14.8104ZM6.79146 14.782C6.80431 14.8544 6.72991 14.9288 6.62368 14.9486C6.51921 14.9676 6.42251 14.9229 6.40917 14.8512C6.39618 14.7769 6.47199 14.7026 6.57625 14.6833C6.68269 14.6648 6.77791 14.7084 6.79146 14.782Z"
                    fill="currentColor"
                  />
                  {'\n'}
                </svg>
              </div>
            </a>
            <a
              href="https://discord.com/invite/jsmC6pXGgX"
              target="_blank"
              className="discord-container w-inline-block"
            >
              <div className="icon-github w-embed">
                <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M15.261 1.15835C17.2939 4.14724 18.2978 7.51863 17.9225 11.3999C17.9209 11.4163 17.9124 11.4314 17.8989 11.4413C16.3594 12.5717 14.8679 13.2577 13.3973 13.7126C13.3859 13.7161 13.3736 13.7159 13.3623 13.7121C13.3509 13.7083 13.3411 13.701 13.3341 13.6913C12.9943 13.2185 12.6856 12.7202 12.4152 12.1968C12.3997 12.166 12.4138 12.1289 12.4458 12.1167C12.9361 11.932 13.4023 11.7106 13.8507 11.4485C13.886 11.4278 13.8883 11.3772 13.8556 11.3529C13.7605 11.2822 13.6662 11.208 13.576 11.1337C13.5591 11.12 13.5364 11.1173 13.5172 11.1265C10.606 12.4709 7.41682 12.4709 4.47113 11.1265C4.452 11.118 4.42928 11.1209 4.41285 11.1344C4.32285 11.2086 4.22835 11.2822 4.13408 11.3529C4.10145 11.3772 4.10415 11.4278 4.1397 11.4485C4.58813 11.7057 5.05432 11.932 5.54392 12.1176C5.57565 12.1298 5.59072 12.166 5.57497 12.1968C5.31037 12.7208 5.00167 13.2192 4.65563 13.6919C4.64055 13.7111 4.6158 13.7198 4.5924 13.7126C3.12878 13.2577 1.63726 12.5717 0.097808 11.4413C0.084983 11.4314 0.075758 11.4156 0.074408 11.3992C-0.239241 8.04198 0.399982 4.64269 2.73345 1.15767C2.73908 1.14845 2.74763 1.14125 2.75753 1.13697C3.9057 0.610022 5.13577 0.222348 6.42142 0.00094849C6.44482 -0.0026515 6.46822 0.00814848 6.48037 0.0288484C6.63922 0.310098 6.8208 0.670772 6.94365 0.965522C8.29882 0.758522 9.67514 0.758522 11.0587 0.965522C11.1815 0.677072 11.3568 0.310098 11.515 0.0288484C11.5206 0.0185794 11.5293 0.0103524 11.5399 0.005342C11.5505 0.000331586 11.5624 -0.0012061 11.5739 0.00094849C12.8602 0.223023 14.0903 0.610697 15.2376 1.13697C15.2477 1.14125 15.256 1.14845 15.261 1.15835V1.15835ZM7.6326 7.54158C7.64677 6.54911 6.92317 5.72786 6.01485 5.72786C5.11395 5.72786 4.39733 6.54191 4.39733 7.54158C4.39733 8.54103 5.12812 9.35508 6.01485 9.35508C6.91597 9.35508 7.6326 8.54103 7.6326 7.54158V7.54158ZM13.6135 7.54158C13.6277 6.54911 12.9041 5.72786 11.996 5.72786C11.0949 5.72786 10.3783 6.54191 10.3783 7.54158C10.3783 8.54103 11.1091 9.35508 11.996 9.35508C12.9041 9.35508 13.6135 8.54103 13.6135 7.54158V7.54158Z"
                    fill="white"
                  />
                  {'\n'}
                </svg>
              </div>
            </a>
            <a
              href="https://console.dbos.dev/launch"
              className="button-cta button-secondary button-thin w-inline-block"
            >
              <div className="text-block">Login</div>
            </a>
            <div className="button-primary-border">
              <a
                href="https://console.dbos.dev/"
                className="button-cta button-primary button-navigation button-thin w-inline-block"
              >
                <div className="text-block">Start your project</div>
              </a>
            </div>
          </div>
        </div>
      </Navbar>
    </div>
  );
}
